import ISBN from 'isbn3';

export const isIsbn = isbnToValidate => {
	return ISBN.parse(isbnToValidate)?.isValid ?? false;
};
